export const cdnHost = 'https://d20yal9ldrtfu9.cloudfront.net';
export const defaultMaleProfileUrl = `https://dxstmhyqfqr1o.cloudfront.net/inbox-demo/avatars/alex.png`;

export const userMetaDataKeys = {
  language: 'language',
  initializedVersion: 'initializedVersion',
  userType: 'userType',
  brandAvatarType: 'brandAvatarType',
  scenario: 'scenario',
};

export const channelMetaDataKeys = {
  state: 'state',
};

export const asyncStorageKeys = {
  savedUser: 'savedUser',
};

export const messageCustomTypes = {
  interactiveResponse: 'interactiveResponse',
  typingIndicator: 'typingIndicator',
  notification: 'notification',
  banner: 'banner',
  marketing: 'marketing',
  splitPayment: 'splitPayment',
  support: 'support',
  vote: 'vote',
  splitCost: 'splitCost',
  csat: 'csat',
  csat5: 'csat5',
  orderConfirmation: 'orderConfirmation',
  map: 'map',
  splitPaymentUpdate: 'splitPaymentUpdate',
  couldNotRecognize: 'couldNotRecognize',
  adminMessageBox: 'adminMessageBox',
  adminMessageBubble: 'adminMessageBubble',
  callStarted: 'callStarted',
  callEnded: 'callEnded',
  bookingsBotStart: 'bookingsBotStart',
  audio: 'audio',
};

export const nonCenteredAdminMessageCustomTypes = [
  messageCustomTypes.splitPayment,
  messageCustomTypes.splitCost,
  messageCustomTypes.csat,
  messageCustomTypes.couldNotRecognize,
  messageCustomTypes.adminMessageBox,
  messageCustomTypes.adminMessageBubble,
];

export const channelCustomTypes = {
  notifications: 'notifications',
  promotions: 'promotions',
  support: 'support',
  delivery: 'delivery',
  banner: 'banner',
};

export const verifiedChannelCustomTypes = [
  channelCustomTypes.notifications,
  channelCustomTypes.promotions,
  channelCustomTypes.support,
];

export const queryKeys = {
  inbox: 'inbox',
};
